import { Card } from '@/components/Card';

export function DirectoryCardSkeleton() {
    return <Card size="narrow" loading />;
}
